import React, { useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import authService from 'src/services/authService';
import * as actions from 'src/redux/actions';
import SplashScreen from 'src/components/SplashScreen';

type AuthProps = {
    children?: any;
    userLoading: boolean,
};

function Auth({ children, userLoading }: AuthProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    const initAuth = async () => {
      authService.handleAuthentication();

      if (authService.isAuthenticated()) {
        dispatch(actions.getCurrentUser());
      } else {
        dispatch(actions.setUserLoading(false));
      }
    };

    initAuth();
  }, [dispatch]);

  if (userLoading) {
    return <SplashScreen />;
  }

  return children;
}

const mapStateToProps = (state: any) => ({
  userLoading: state.account.isLoading
});

export default connect(mapStateToProps)(Auth);
